export type Letter = {
  letter: string;
  answer?: string;
}

export type Word = {
  letters: Letter[];
}

export type Game = {
  date: string;
  tries: string[];
}

const today = new Date().toISOString().split('T')[0];
const STATE_BASE = 'gamestate';
const TODAY = `${STATE_BASE}-${today}`;
const database = window.localStorage;

const createStateForToday = () => {
  const hasPlayedToday = database.getItem(TODAY);
  if (hasPlayedToday) {
    return
  }

  const newState = {
    date: today,
    tries: [],
  } as Game;

  database.setItem(TODAY, JSON.stringify(newState));
}

export const initState = () => {
  createStateForToday();
}

export const getTodaysState = () => {
  const todaysData = database.getItem(TODAY);
  if(!todaysData) {
    return [];
  }

  const todaysGameState = JSON.parse(todaysData) as Game;
  return todaysGameState.tries;
}

export const saveGuess = (letters:Letter[]) => {
  const guessToSave = letters.map(({letter}) => letter).join('')
  const todaysData = database.getItem(TODAY);
  if(!todaysData) {
    return;
  }

  const todaysGameState = JSON.parse(todaysData) as Game;
  todaysGameState.tries.push(guessToSave)
  database.setItem(TODAY, JSON.stringify(todaysGameState))
}
